import React from "react";
import { useTranslation } from "react-i18next";
import greenDotIcon from "../../../assets/images/green-dot2.png";
import smallErrorIcon from "../../../assets/images/red-alert-icon.png";
import "./DepositStatusIcon.scss";

const DepositStatusIcon = ({ isDepositOk }) => {
  const { t } = useTranslation("common");
  return (
    <>
      <img src={isDepositOk ? greenDotIcon : smallErrorIcon} alt="" />
      <span
        className="deposit-status-icon-label"
        // style={{ marginRight: `${!isDepositOk && "11px"}` }}
      >
        {isDepositOk ? t("general.yes") : t("general.no")}
      </span>
    </>
  );
};

export default DepositStatusIcon;
